import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { authReducer } from 'state/auth';
import { guideReducer } from 'state/guide';
import { layerReducer } from 'state/layers';
import { feedbackReducer } from 'state/feedback';
import { focusareasReducer } from 'state/focusareas';
import { fuelmanagementregisterReducer } from 'state/fuelmanagementregister';
import { firetrailReducer } from 'state/firetrail';
import toastReducer from 'state/toast';
import usersReducer from 'state/user';
import rolesReducer from 'state/role';
import redliningReducer from 'state/redlining';
import { faftPrioritisationReducer } from 'state/faftprioritisation';
import { faftWorkTypesReducer } from 'state/faftworktypes';

const rootReducer = combineReducers({
    auth: authReducer,
    layers: layerReducer,
    guide: guideReducer,
    users: usersReducer,
    feedback: feedbackReducer,
    roles: rolesReducer,
    focusarea: focusareasReducer,
    fuelmanagementregister: fuelmanagementregisterReducer,
    firetrail: firetrailReducer,
    redlining: redliningReducer,
    toasts: toastReducer,
    faftprioritisation: faftPrioritisationReducer,
    faftworktypes: faftWorkTypesReducer,
});

export const store = configureStore({
    reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

/**
 * Intended to be used by tests
 * @param state The inital state of the Redux App
 * @returns A new redux store, with an initial state
 */
export const makeStoreWithState = (state?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        preloadedState: state,
    });

export default store;
